import "./App.css";
import ProjectRoutes from "./Routes";
import { Bounce, ToastContainer } from "react-toastify";
import "./global.css";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";

import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
// import Bugsnag from "@bugsnag/js";
// import BugsnagPluginReact from "@bugsnag/plugin-react";
// import BugsnagPerformance from "@bugsnag/browser-performance";

// Bugsnag.start({
//   apiKey: "694c291210e1a7dc2bdef390801e629e",
//   plugins: [new BugsnagPluginReact()],
// });
// BugsnagPerformance.start({ apiKey: "694c291210e1a7dc2bdef390801e629e" });

// const ErrorBoundary = Bugsnag.getPlugin("react").createErrorBoundary(React);

const App = () => {
  const { i18n } = useTranslation();


   useEffect(() => {
    if (i18n.language === "ar") {
      document.body.classList.add("arabic-font");
    } else {
      document.body.classList.remove("arabic-font");
    }
  }, [i18n.language]);

  return (
    // <ErrorBoundary>
      <div className="App">
        <ProjectRoutes />
        <ToastContainer
          autoClose={2000}
          theme="colored"
          position="top-right"
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {/* <button onClick={handleClick}>Trigger error</button> */}
      </div>
  );
};

export default App;
